import React from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import style from '../forecasting-grid.module.less';
import messages from '../messages';

/**
 * @typedef {object} ProductData
 * @property {string} imageUrl - Product image URL
 * @property {string} productName - Product name
 * @property {string} sku - Product SKU
 */

/**
 * Product column component for the forecasting grid
 * @param {object} props - Component props
 * @param {ProductData} props.product - Product data
 * @returns {React.ReactElement} The rendered Product column component
 */
export const ProductColumn = ({ product }) => {
  const { imageUrl, productName, sku } = product;

  return (
    <div className={classnames(style['product-cell'])}>
      <div className={classnames(style['product-image'])}>
        {imageUrl ? (
          <img alt='Product' className={classnames(style['product-thumbnail'])} src={imageUrl} />
        ) : (
          <div className={classnames(style['product-thumbnail-placeholder'])} />
        )}
      </div>
      <div className={classnames(style['product-info'])}>
        <div className={classnames(style['product-name'])}>{productName}</div>
        <div className={classnames(style['product-sku'])}>
          <FormattedMessage {...messages.skuLabel} /> {sku}
        </div>
      </div>
    </div>
  );
};
